export const showDataActionType = {
    SET_SHOW_RXS: 'SET_SHOW_RXS',
    SET_SHOW_PTS: 'SET_SHOW_PTS',
    SET_SHOW_DOCS: 'SET_SHOW_DOCS',
    SET_SHOW_RX_SUBTITLE: 'SET_SHOW_RX_SUBTITLE',
}